export const ROUTE_DIVISION_START = "ROUTE_DIVISION_START" as const;
export const ROUTE_DIVISION_STARTED = "ROUTE_DIVISION_STARTED" as const;
export const ROUTE_DIVISION_ERROR = "ROUTE_DIVISION_ERROR" as const;
export const ROUTE_DIVISION_RESET = "ROUTE_DIVISION_RESET" as const;
export const ROUTE_DIVISION_BY_AREA_START = "ROUTE_DIVISION_BY_AREA_START" as const;

export interface RouteDivisionStartPayload {
  state: string;
  // city is optional — can be made required again by changing to `city: string`
  city?: string;
  // Country (ISO-2 code) — drives Guard A (unsupported-country routing fallback).
  country?: string;
  depot_address: {
    street_name: string;
    city: string;
    state: string;
    zip_code: string;
    country: string;
    latitude: number;
    longitude: number;
    place_id?: string;
  };
  route_name_prefix: string;
  min_vehicles?: number;
  max_per_vehicle?: number;
  project_id?: number;
}

export interface RouteDivisionByAreaPayload {
  household_ids: number[];
  // Country (ISO-2 code or name) — drives Guard A (unsupported-country routing fallback).
  country?: string;
  depot_address: {
    street_name: string;
    city: string;
    state: string;
    zip_code: string;
    country: string;
    latitude: number;
    longitude: number;
    place_id?: string;
    [key: string]: any;
  };
  route_name_prefix: string;
  min_vehicles?: number;
  max_per_vehicle?: number;
  project_id?: number;
}

export const routeDivisionStartAC = (payload: RouteDivisionStartPayload) => ({
  type: ROUTE_DIVISION_START,
  payload,
});

export const routeDivisionByAreaStartAC = (payload: RouteDivisionByAreaPayload) => ({
  type: ROUTE_DIVISION_BY_AREA_START,
  payload,
});

export const routeDivisionStartedAC = () => ({
  type: ROUTE_DIVISION_STARTED,
});

export const routeDivisionErrorAC = (error: string) => ({
  type: ROUTE_DIVISION_ERROR,
  payload: error,
});

export const routeDivisionResetAC = () => ({
  type: ROUTE_DIVISION_RESET,
});

export type RouteDivisionActions =
  | ReturnType<typeof routeDivisionStartAC>
  | ReturnType<typeof routeDivisionByAreaStartAC>
  | ReturnType<typeof routeDivisionStartedAC>
  | ReturnType<typeof routeDivisionErrorAC>
  | ReturnType<typeof routeDivisionResetAC>;
